import React from 'react';

import { styled } from '@mui/material';

import AnimatedSkeleton from '~/components/AnimatedSkeleton';
import AnimatedSkeletonMultiline from '~/components/AnimatedSkeletonMultiline';
import Card from '~/components/Card/Card';
import CardInfo from '~/components/Card/components/CardInfo/CardInfo';
import Ratio from '~/components/Ratio';
import {
  SKELETON_TEXT_HEIGHT_SMALL_PX,
  SKELETON_TEXT_HEIGHT_TINY_PX,
  SMALL_MARGIN_PX,
  TINY_MARGIN_PX,
} from '~/theme';

const HitLoadingCard = ({ withCategories = true }) => {
  return (
    <li>
      <Card>
        <StyledRatio ratio={68}>
          <AnimatedSkeleton xs="100%" />
        </StyledRatio>
        <CardInfo>
          {withCategories && (
            <CategoriesWrapper>
              <LoadingCategory />
              <LoadingCategory />
            </CategoriesWrapper>
          )}
          <LoadingTitle xs={SKELETON_TEXT_HEIGHT_SMALL_PX} />
          <LoadingDescription xs={SKELETON_TEXT_HEIGHT_TINY_PX} lines={4} spacer={TINY_MARGIN_PX} />
          <LoadingMeta xs={SKELETON_TEXT_HEIGHT_TINY_PX} />
        </CardInfo>
      </Card>
    </li>
  );
};

export default HitLoadingCard;

const StyledRatio = styled(Ratio)`
  flex: 1;
  margin-bottom: ${SMALL_MARGIN_PX};
  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: 0;
  }
`;

const CategoriesWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  & > *:first-child {
    width: 130px;
  }
  & > *:nth-child(2) {
    width: 170px;
  }
`;

const LoadingCategory = styled(AnimatedSkeleton)`
  margin-right: 10px;
  margin-bottom: ${SMALL_MARGIN_PX};
  height: 29px;
`;

const LoadingTitle = styled(AnimatedSkeleton)`
  margin-bottom: ${SMALL_MARGIN_PX};
  width: 70%;
`;

const LoadingDescription = styled(AnimatedSkeletonMultiline)`
  margin-bottom: ${SMALL_MARGIN_PX};
`;

const LoadingMeta = styled(AnimatedSkeleton)`
  width: 50%;
`;
